import { render } from "./Formato1980.vue?vue&type=template&id=acef0abc&scoped=true"
import script from "./Formato1980.vue?vue&type=script&lang=js"
export * from "./Formato1980.vue?vue&type=script&lang=js"

import "./Formato1980.vue?vue&type=style&index=0&id=acef0abc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acef0abc"]])

export default __exports__